import React from "react"



const StepTwo = () => {
    return(
        <div className="step-2 steps">
             <div className="display-lap2">
                <h1>Verification</h1>
                <p>We will verify your employment. Employment verification is automated and approval of your loan amount and tenure by your employer takes less than 5mins.</p>
            </div>
        </div>
    )
}

export default StepTwo